"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayerImpl = exports.useLayerWithExposureLoggingDisabledImpl = exports.useExperimentImpl = exports.useExperimentWithExposureLoggingDisabledImpl = exports.useConfigImpl = exports.useGateImpl = exports.useGateWithExposureLoggingDisabledImpl = exports.useFeatureGateImpl = void 0;
var react_1 = require("react");
var statsig_js_1 = require("statsig-js");
var StatsigContext_1 = __importDefault(require("./StatsigContext"));
var Statsig_1 = __importDefault(require("./Statsig"));
function useFeatureGateImpl(gateName, options) {
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, userVersion = _a.userVersion, initStarted = _a.initStarted;
    var gate = (0, react_1.useMemo)(function () {
        return initStarted
            ? Statsig_1.default.getFeatureGate(gateName, options)
            : new statsig_js_1.FeatureGate(gateName, false, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        gateName,
        userVersion,
        options === null || options === void 0 ? void 0 : options.ignoreOverrides,
        options === null || options === void 0 ? void 0 : options.disableExposureLogging,
    ]);
    return {
        isLoading: !initialized,
        gate: gate,
    };
}
exports.useFeatureGateImpl = useFeatureGateImpl;
function useGateWithExposureLoggingDisabledImpl(gateName, options) {
    var _a;
    return useGateImpl(gateName, (_a = options === null || options === void 0 ? void 0 : options.ignoreOverrides) !== null && _a !== void 0 ? _a : false, true);
}
exports.useGateWithExposureLoggingDisabledImpl = useGateWithExposureLoggingDisabledImpl;
function useGateImpl(gateName, ignoreOverrides, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, userVersion = _a.userVersion, initStarted = _a.initStarted, hooksMemoKey = _a.hooksMemoKey;
    var gate = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.checkGateWithExposureLoggingDisabled(gateName, { ignoreOverrides: ignoreOverrides })
                : Statsig_1.default.checkGate(gateName, ignoreOverrides)
            : false;
    }, [
        initialized,
        initStarted,
        gateName,
        userVersion,
        ignoreOverrides,
        exposureLoggingDisabled,
        hooksMemoKey,
    ]);
    return {
        isLoading: !initialized,
        value: gate,
    };
}
exports.useGateImpl = useGateImpl;
function useConfigImpl(configName, ignoreOverrides, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion, hooksMemoKey = _a.hooksMemoKey;
    var config = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.getConfigWithExposureLoggingDisabled(configName, { ignoreOverrides: ignoreOverrides })
                : Statsig_1.default.getConfig(configName, ignoreOverrides)
            : new statsig_js_1.DynamicConfig(configName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        configName,
        userVersion,
        ignoreOverrides,
        exposureLoggingDisabled,
        hooksMemoKey,
    ]);
    return {
        isLoading: !initialized,
        config: config,
    };
}
exports.useConfigImpl = useConfigImpl;
function useExperimentWithExposureLoggingDisabledImpl(experimentName, options) {
    var _a, _b;
    return useExperimentImpl(experimentName, (_a = options === null || options === void 0 ? void 0 : options.keepDeviceValue) !== null && _a !== void 0 ? _a : false, (_b = options === null || options === void 0 ? void 0 : options.ignoreOverrides) !== null && _b !== void 0 ? _b : false, true);
}
exports.useExperimentWithExposureLoggingDisabledImpl = useExperimentWithExposureLoggingDisabledImpl;
function useExperimentImpl(experimentName, keepDeviceValue, ignoreOverrides, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion, hooksMemoKey = _a.hooksMemoKey;
    var config = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.getExperimentWithExposureLoggingDisabled(experimentName, {
                    keepDeviceValue: keepDeviceValue,
                    ignoreOverrides: ignoreOverrides,
                })
                : Statsig_1.default.getExperiment(experimentName, keepDeviceValue, ignoreOverrides)
            : new statsig_js_1.DynamicConfig(experimentName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        experimentName,
        userVersion,
        keepDeviceValue,
        ignoreOverrides,
        exposureLoggingDisabled,
        hooksMemoKey,
    ]);
    return {
        isLoading: !initialized,
        config: config,
    };
}
exports.useExperimentImpl = useExperimentImpl;
function useLayerWithExposureLoggingDisabledImpl(layerName, options) {
    var _a;
    return useLayerImpl(layerName, (_a = options === null || options === void 0 ? void 0 : options.keepDeviceValue) !== null && _a !== void 0 ? _a : false, true);
}
exports.useLayerWithExposureLoggingDisabledImpl = useLayerWithExposureLoggingDisabledImpl;
function useLayerImpl(layerName, keepDeviceValue, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion, hooksMemoKey = _a.hooksMemoKey;
    var layer = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.getLayerWithExposureLoggingDisabled(layerName, { keepDeviceValue: keepDeviceValue })
                : Statsig_1.default.getLayer(layerName, keepDeviceValue)
            : statsig_js_1.Layer._create(layerName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        layerName,
        userVersion,
        keepDeviceValue,
        exposureLoggingDisabled,
        hooksMemoKey,
    ]);
    return {
        isLoading: !initialized,
        layer: layer,
    };
}
exports.useLayerImpl = useLayerImpl;
